import React from 'react';
import { useParams } from 'react-router-dom';
import { Box, Stack } from '@mui/material';
import '../../../styles/DocumentDetails.css';
import TopBar from '../../../components/TopBar';
import useDocumentTitle from '../../../hooks/useDocumentTitle';
import DebitNoteDetailsPageActionButton from '../components/DebitNoteDetailsPageActionButton';
import DebitNoteForm from '../components/DebitNoteForm';
import IrbmStatusCard from '../../common/IrbmStatusCard';
import { useGetDebitNoteHandler } from '../dataHandlers/getCreditNoteHandler';
import DocumentSkeletonForm from '../../../components/DocumentSkeletonForm';

export default function DebitNoteDetailsPage() {
  useDocumentTitle('Debit Note Details');
  const { document_id } = useParams();
  const { debitNote, isLoading } = useGetDebitNoteHandler(document_id);
  if (isLoading || !debitNote) {
    return <DocumentSkeletonForm />;
  }

  return (
    <Stack direction="column" sx={{ mt: '-1rem' }}>
      {debitNote && (
        <Box sx={{ pb: 4 }}>
          <TopBar title="Debit Note Details" identifier={debitNote?.document_id}>
            <DebitNoteDetailsPageActionButton data={debitNote} />
          </TopBar>
        </Box>
      )}
      <IrbmStatusCard document={debitNote} />

      <DebitNoteForm onSubmit={() => {}} onCancel={() => {}} initialData={debitNote} readOnly={true} />
    </Stack>
  );
}
